<template>
  <div>
    <post-card
      v-for="post in posts"
      :key="post.id"
      :post="post"
    />
    <div class="more-posts">
      <q-button @click="morePosts">
        <span>{{ this.$qt('blog.morePostsText') }}</span>
      </q-button>
    </div>
  </div>
</template>

<script>

  import postCard from './postCard';

  export default {
    name: "BlogList",

    components: {
      'post-card': postCard
    },

    props: {
      category: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        page: 1,
        pageQty: 0,
        itemsQty: 0,
        itemsInPage: 6,
        posts: []
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize(to.params.category));
    },

    beforeRouteUpdate(to, from, next) {
      this.initialize(to.params.category);
      next(vm => vm.initialize(to.params.category));
    },

    computed: {},

    methods: {
      initialize(categoryKey) {
        this.$delegate('edms', 'getContentsInCategory', {
          category: categoryKey,
          page: 1,
          itemsInPage: 3
        }).then((res) => {

          this.posts = res.result.posts;
          this.itemsInPage = res.result.itemsInPage;
          this.itemsQty = res.result.itemsQty;
          this.pageQty = res.result.pageQty;
          this.page = res.result.page;

        }).catch(() => {
        });
      },
      morePosts() {
        this.$delegate('edms', 'getContentsInCategory', {
          category: this.category,
          page: this.page + 1,
          itemsInPage: this.itemsInPage
        }).then((res) => {
          let _posts = res.result.posts;
          this.itemsInPage = res.result.itemsInPage;
          this.itemsQty = res.result.itemsQty;
          this.pageQty = res.result.pageQty;
          this.page = res.result.page;
          _posts.forEach((item) => {
            this.posts.push(item);
          });
        }).catch(() => {
        });
      }
    }
  }
</script>

<style scoped>
  .more-posts {
    width: 100%;
    text-align: center;
    padding: 20px 0;
  }
</style>